module.exports = __webpack_public_path__ + "media/images/emblems/Emmen_LU-3608a90b3d2440ca4e7102b36cead762.png";